// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__vlPz9","spinner":"MGLoader_spinner__IWEYr","mg-loader-spin":"MGLoader_mg-loader-spin__ov66c"};